export const createUUID = (): string => {
  return crypto.randomUUID();
};
